/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../ui-elements/touchable.directive';
import * as import2 from '@angular/common';
import * as import3 from './dietary-panel.component';
const styles_DietaryPanelComponent:any[] = ([] as any[]);
export const RenderType_DietaryPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_DietaryPanelComponent,
  data: {}
}
);
function View_DietaryPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'kilojoules'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n    ',
      ' kJ\n'
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.sellable.kiloJoules;
    ck(v,1,0,currVal_0);
  });
}
function View_DietaryPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',[
      [
        'class',
        'indicators-indicator'
      ]
      ,
      [
        'woa-touchable',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(4210688,(null as any),0,import1.TouchableDirective,[import0.ElementRef],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,[[
        'label',
        1
      ]
      ],(null as any),3,'div',[[
        'class',
        'indicators-indicator-tooltip'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import2.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['left']),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,[[
        'icon',
        1
      ]
      ],(null as any),6,'div',[[
        'class',
        'indicators-indicator-icon'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'indicators-indicator-icon-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import2.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['compressed']),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'indicators-indicator-tooltip';
    const currVal_1:any = ck(v,5,0,co.tooltipLeft(import0.ɵnov(v,8),import0.ɵnov(v,3)));
    ck(v,4,0,currVal_0,currVal_1);
    const currVal_3:any = 'indicators-indicator-icon-text';
    const currVal_4:any = ck(v,12,0,(v.context.$implicit.code.length > 2));
    ck(v,11,0,currVal_3,currVal_4);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = (v.context.$implicit.name || v.context.$implicit.code);
    ck(v,6,0,currVal_2);
    const currVal_5:any = co.getDisplayedIndicatorCode(v.context.$implicit);
    ck(v,13,0,currVal_5);
  });
}
function View_DietaryPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'indicators'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DietaryPanelComponent_3)),
    import0.ɵdid(802816,(null as any),0,import2.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
    ,{
      ngForOf: [
        0,
        'ngForOf'
      ]
      ,
      ngForTrackBy: [
        1,
        'ngForTrackBy'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.sellable.dietaryIndicators;
    const currVal_1:any = co.trackIndicatorByFn;
    ck(v,3,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_DietaryPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DietaryPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DietaryPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import3.DietaryPanelComponent = v.component;
    const currVal_0:any = co.sellable.kiloJoules;
    ck(v,1,0,currVal_0);
    const currVal_1:any = (co.MenuEvents.currentMenu.value && co.sellable.dietaryIndicators.length);
    ck(v,4,0,currVal_1);
  },(null as any));
}
function View_DietaryPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-dietary-panel',([] as any[]),(null as any),(null as any),(null as any),View_DietaryPanelComponent_0,RenderType_DietaryPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import3.DietaryPanelComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const DietaryPanelComponentNgFactory:import0.ComponentFactory<import3.DietaryPanelComponent> = import0.ɵccf('woa-dietary-panel',import3.DietaryPanelComponent,View_DietaryPanelComponent_Host_0,{sellable: 'sellable'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/order/order-item/dietary-panel/dietary-panel.component.ngfactory.ts